import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Box, MenuItem, Select, Paper, Grid } from "@mui/material";
import axiosInstance from "../../utils/axiosConfig";

export const ExpandedRowContent = ({ data, fetchClients }) => {
  const { t } = useTranslation();

  const handleElevatorStatusChange = async (
    locationId,
    buildingId,
    elevatorId,
    newStatus
  ) => {
    try {
      await axiosInstance.patch(
        `/clients/${data.id}/locations/${locationId}/buildings/${buildingId}/elevators/${elevatorId}`,
        { elevator: { status: newStatus } }
      );
      fetchClients();
    } catch (error) {
      console.error("Error updating elevator status:", error);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      {data.locations.map((location) => (
        <Paper key={location.id} sx={{ p: 2, mb: 2, backgroundColor: "#f5f5f5" }}>
          <Typography variant="h6" sx={{ mb: 2, color: "#1976d2" }}>
            {t("location")}: {location.name}
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {t("address")}: {location.address}
          </Typography>

          <Grid container spacing={2}>
            {location.buildings.map((building) => (
              <Grid item xs={12} md={6} key={building.id}>
                <Paper sx={{ p: 2, backgroundColor: "white" }}>
                  <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
                    {t("building")}: {building.name}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 2 }}>
                    {t("numberOfFloors")}: {building.floors}
                  </Typography>

                  {building.elevators.map((elevator) => (
                    <Box
                      key={elevator.id}
                      sx={{
                        p: 1,
                        mb: 1,
                        border: "1px solid #e0e0e0",
                        borderRadius: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box>
                        <Typography variant="body1">
                          {t("elevatorId")}: {elevator.identifier}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {t("capacity")}: {elevator.capacity} {t("kg")}
                        </Typography>
                      </Box>
                      <Select
                        value={elevator.status}
                        size="small"
                        sx={{ minWidth: 150 }}
                        onChange={(e) =>
                          handleElevatorStatusChange(
                            location.id,
                            building.id,
                            elevator.id,
                            e.target.value
                          )
                        }
                      >
                        <MenuItem value="operational">{t("operational")}</MenuItem>
                        <MenuItem value="maintenance">{t("maintenance")}</MenuItem>
                        <MenuItem value="out_of_service">{t("out_of_service")}</MenuItem>
                      </Select>
                    </Box>
                  ))}
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Paper>
      ))}
    </Box>
  );
};
